<template>
  <div class="cp-section">
    <OrderList :input="input" :params="params" title="Order History" />
  </div>
</template>

<script>
const OrderList = () => import('./../Order/OrderList')

export default {
  name: 'CustomerPortalOrderHistory',
  components: {OrderList},
  props: {
    input: Object
  },
  data: function() {
    return {
      params: {
        is_active: false
      }
    }
  }
}
</script>

<style scoped>

</style>
